const getGlobalStyles = () => ({
  html: {
    height: "100%",
    width: "100%",
    overflow: "hidden",
  },

  body: {
    fontFamily: "Montserrat",
    height: "100%",
    width: "100%",
    margin: "0%",
    overflow: "hidden",
  },

  ":root": {
    "--color-hex": "#1E1E1E",
  },

  ".appLayout": {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    overflow: "hidden",
  },

  ".appLayoutContent": {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
  },
});

export default getGlobalStyles;
